// 企业信息
export default {
    companyName: 'Company Name',
    administrator: 'Administrator',
    contactInformation: 'Contact Information',
    authorizationModule: 'Authorization Module',
    logoSettings: 'Logo Settings',
    logoUpload: 'Logo Upload',
    imageFormatWrong: 'The uploaded image is in the wrong format',
}
